import { PureComponent, cloneElement } from "react";
import classNames from "classnames";
import { ALIGN_TYPES } from "constants/align-types";
import { componentStyles } from "./tabs-component.scss";
import { scrollTo, isNodeFullyInView } from "/services/dom-utils-service";

export default class TabsComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      activeTabIndex: props.defaultActiveTabIndex
    };

    this.contentNode = React.createRef();

    this.handleTabClick = this.handleTabClick.bind(this);
  }

  componentDidMount() {
    const { autoTransition } = this.props;
    if (autoTransition) this.playAutoTransition();
  }

  componentWillUnmount() {
    if (this._changeActiveIndexInterval) clearInterval(this._changeActiveIndexInterval);
  }

  playAutoTransition() {
    const { autoTransition } = this.props;

    this._changeActiveIndexInterval = setInterval(() => {
      const { activeTabIndex } = this.state;
      const { children } = this.props;
      this.setState({ activeTabIndex: (activeTabIndex + 1) % children.length });
    }, autoTransition);
  }

  async handleTabClick(index) {
    const { scrollSpeed, scrollOnTabClick, distanceFromTop } = this.props;
    if (this._changeActiveIndexInterval) clearInterval(this._changeActiveIndexInterval);
    const node = this.contentNode?.current;

    try {
      if (scrollOnTabClick && node && !(await isNodeFullyInView(node))) {
        scrollTo(this.contentNode.current.offsetTop - distanceFromTop, scrollSpeed);
      }
    } catch (e) {}

    this.setState({
      activeTabIndex: index
    });
  }

  tabsRenderer() {
    const { children } = this.props;
    const { activeTabIndex } = this.state;

    return children.map((child, index) => {
      return cloneElement(child, {
        onClick: this.handleTabClick,
        index,
        isActive: index === activeTabIndex
      });
    });
  }

  contentRenderer() {
    const { children } = this.props;
    const { activeTabIndex } = this.state;

    if (children[activeTabIndex]) {
      return children[activeTabIndex].props.children;
    }
  }

  render() {
    const { className, tabsAlign } = this.props;
    return (
      <div
        className={classNames("tabs-component", className, tabsAlign)}
        ref={this.contentNode}
        role="tablist"
        aria-level="documentation-navigation"
      >
        <div className="tabs">{this.tabsRenderer()}</div>
        <div className="content" role="tabpanel">
          {this.contentRenderer()}
        </div>

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

TabsComponent.defaultProps = {
  children: [],
  defaultActiveTabIndex: 0,
  autoTransition: "30000",
  scrollSpeed: 200,
  scrollOnTabClick: false,
  distanceFromTop: 0,
  className: "",
  tabsAlign: ALIGN_TYPES.CENTER
};
